import { useState } from 'react';
import { Target } from '@fluentui/react-hooks';
import { z } from 'zod';

export const expandedMenuDataSchema = z.object({ activeLabel: z.string() });

export default <Data = unknown>() => {
  const [menuData, setMenuData] = useState<Data | null>(null);
  const [menuTarget, setMenuTarget] = useState<Target | null>(null);

  const openChartContextMenu = (target: Target, data?: Data) => {
    setMenuTarget(target);

    if (data) {
      setMenuData(data);
    }
  };

  const closeChartContextMenu = () => {
    setMenuTarget(null);

    setMenuData(null);
  };

  return {
    menuTarget,
    menuData,
    openChartContextMenu,
    closeChartContextMenu,
  };
};
